export const USERS_API_URL = process.env.REACT_APP_USERS_API_URL;
export const CARRIERS_API_URL= process.env.REACT_APP_CARRIERS_API_URL;
export const ASSETS_API_URL = process.env.REACT_APP_ASSETS_API_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT
export const SENTRY_URL = process.env.REACT_APP_SENTRY;